<template>
  <div class="edit-profile-modal">
    <label for="name">First Name</label>
    <input id="name" type="text" v-model="firstname" />
    <label for="last-name">Last Name</label>
    <input id="last-name" type="text" v-model="lastname" />
    <label for="email">E-mail</label>
    <input id="email" type="text" v-model="email" />
    <div class="buttons">
      <button class="change-button" @click="editUser">
        {{ $t("button.editProfile") }}
      </button>
      <button class="cancel-button" @click="$emit('close-modal')">
        {{ $t("button.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    userId: Number,
    originalName: String,
    originalLastname: String,
    originalEmail: String,
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
    };
  },
  methods: {
    async editUser() {
      const params = {
        usr_id: this.userId,
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
      };
      try {
        const res = await api.editUser(params);
        this.$emit("closeAndRefresh");
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  mounted() {
    console.log(this.originalName);
    this.email = this.originalEmail;
    this.lastname = this.originalLastname;
    this.firstname = this.originalName;
  },
};
</script>

<style lang='scss' scoped>
.edit-profile-modal {
  width: 100%;
  height: 100%;
}
.change-password-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 10% 0;
}
.buttons button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: none;
  padding: 10px;
  border-radius: 100px;
  font-size: 16px;
  height: 40px;
  width: 70%;
}
.change-button {
  background: var(--button-color-blue);
  color: white;
  margin-bottom: 3%;
}
.buttons button:active,
.buttons button:focus {
  outline: none;
  border: none;
}
.input-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 70%;
  margin-bottom: 2%;
}
label {
  font-size: 0.7em;
}
.input-wrap input.hasError {
  border: 1.5px solid red;
}
.error {
  color: red;
  font-size: 0.5em;
}
.errors {
  display: flex;
  flex-direction: column;
  margin: 0;
}
</style>